var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OfferWrapper',{attrs:{"back-link":_vm.backLink}})}
var staticRenderFns = []

export { render, staticRenderFns }